import React from 'react';
import PropTypes from 'prop-types';

import {formToJSON} from '../../utils/misc';

import './style.css';


export class Form extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        let data = formToJSON(this.form);

        this.props.action(data);
    }

    render() {
        return (
            <form className={this.props.className} onSubmit={this.handleSubmit} ref={(form) => {
                this.form = form;
            }}>
                {this.props.children}
            </form>
        );
    }
}

Form.propTypes = {
    action: PropTypes.func.isRequired,
    children: PropTypes.arrayOf(
        PropTypes.element
    ),
    className: PropTypes.string
};

Form.defaultProps = {
    className: 'form'
};


export const HiddenInput = ({name, value}) => {
    // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
    return <input
        type="text" className="input" readOnly autoComplete="nope" name={name} value={value}
        style={{display: 'none'}}/>;
};


HiddenInput.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
};


export const FormField = (props) => {
    const Label = props.label ? <label className="label is-small">{props.label}</label> : null;

    return (
        <div className="field" style={props.style}>
            {Label}
            <div className={`control ${props.controlClass}`}>
                {props.children}
            </div>
            {props.helper}
        </div>
    );
};


FormField.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element)
    ]),
    label: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string
    ]),
    helper: PropTypes.element,
    controlClass: PropTypes.string,
    style: PropTypes.object
};

FormField.defaultProps = {
    helper: null,
    controlClass: '',
    style: null
};

export default FormField;
